/**
 * *! This helper has unit tests.
 * If you make any changes to this file, you should run the unit tests:
 * npm test src/utest/addons/addon_serial_helpers.test.ts
 */

import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
import { devices_status } from 'src/stores';
import { SERIAL_MODE_LABELS, SERIAL_MODES_MAP } from './addon_serial_helpers';
//Types
import type { Peripheral } from 'src/types/Peripherals';

export const SERIAL_MODES_DESCRIPTIONS: Record<string, { key: string; default: string }> = {
	[SERIAL_MODES_MAP.disabled]: {
		key: 'description_serial_mode_disabled',
		default:
			'Serial port is not utilized by any function. If the Serial instance shares hardware with a serial port used for debug output or other functions, these other functions are suspended or disabled.',
	},
	[SERIAL_MODES_MAP.jsUart]: {
		key: 'description_serial_mode_js_uart',
		default:
			'Scripts can use the UART Js APIs to utilize the serial port peripheral. Only one script can use the Serial at a time.',
	},
	[SERIAL_MODES_MAP.mbServer]: {
		key: 'description_serial_mode_mb_server',
		default:
			'Serial acts as a Modbus RTU Server. This mode is only supported on devices with Modbus support.',
	},
	[SERIAL_MODES_MAP.mbClient]: {
		key: 'description_serial_mode_mb_client',
		default:
			'Operates as a Modbus RTU Client. Creates an MbRtuClient component instance with the same id as the Serial instance, exposing raw register and coil read/write RPC methods.',
	},
};

export const getSupportedModeOptions = (peripheral: Peripheral): { value: string; title: string }[] => {
	const $format = get(format);
	const component = peripheral.sensor.component;
	const statuses = devices_status.getByRealId(peripheral.deviceID);
	const knownModes = new Set(Object.values(SERIAL_MODES_MAP));
	const availabledModes = statuses?.[component]?._attrs?.modes;
	const supportedModes = Array.isArray(availabledModes)
		? availabledModes.filter((mode) => knownModes.has(mode))
		: [];
	return [...new Set([SERIAL_MODES_MAP.disabled, ...supportedModes])].map((value) => {
		const entry = SERIAL_MODE_LABELS[value];
		return {
			title: entry ? $format(entry.key, { default: entry.default }) : value,
			value,
		};
	});
};
